import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { AdminLayout } from "@/admin/AdminLayout";

export default function AdminGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(location.state?.user?.is_admin ? location.state.user : null);

  useEffect(() => {
    if (user) return;
    api
      .get("/auth/me")
      .then(({ data }) => (data.is_admin ? setUser(data) : navigate("/admin/login", { replace: true })))
      .catch(() => navigate("/admin/login", { replace: true }));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    document.title = "Redacción · El Noticiero";
    let robots = document.head.querySelector('meta[name="robots"]');
    if (robots) robots.setAttribute("content", "noindex, nofollow");
  }, [location.pathname]);

  if (!user)
    return (
      <div className="min-h-screen grid place-items-center bg-background" data-testid="admin-checking">
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    );
  return (
    <AdminLayout user={user}>
      <Outlet context={{ user }} />
    </AdminLayout>
  );
}
